(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function bestImageSrc(img) {
    if (img.srcset) {
      var best = '';
      var bestW = 0;
      img.srcset.split(',').forEach(function (part) {
        var bits = part.trim().split(/\s+/);
        var url = bits[0];
        var w = parseInt(bits[1], 10) || 0;
        if (w >= bestW) {
          bestW = w;
          best = url;
        }
      });
      if (best) return best;
    }
    return img.currentSrc || img.src;
  }

  function disableMagnifyOnMobile() {
    if (!MOBILE.matches) return;
    document.querySelectorAll('.image-magnify-hover').forEach(function (img) {
      img.onclick = null;
      img.style.cursor = 'zoom-in';
    });
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function openZoomViewer(img) {
    if (!MOBILE.matches) return;

    var src = bestImageSrc(img);
    var overlay = document.createElement('div');
    overlay.className = 'be-zoom-viewer';
    overlay.innerHTML =
      '<button type="button" class="be-zoom-viewer__close" aria-label="Kapat">×</button>' +
      '<div class="be-zoom-viewer__stage"><img class="be-zoom-viewer__img" alt="" /></div>' +
      '<p class="be-zoom-viewer__hint">İki parmakla yakınlaştır · Sürükleyerek gez · Çift dokun</p>';

    var stage = overlay.querySelector('.be-zoom-viewer__stage');
    var zoomImg = overlay.querySelector('.be-zoom-viewer__img');
    zoomImg.src = src;
    zoomImg.alt = img.alt || '';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var scale = 1;
    var tx = 0;
    var ty = 0;
    var startDist = 0;
    var startScale = 1;
    var startTx = 0;
    var startTy = 0;
    var lastPanX = 0;
    var lastPanY = 0;
    var panning = false;
    var lastTap = 0;

    function baseSize() {
      return {
        w: zoomImg.clientWidth || zoomImg.naturalWidth,
        h: zoomImg.clientHeight || zoomImg.naturalHeight,
      };
    }

    function clampTransform() {
      var base = baseSize();
      var sw = stage.clientWidth;
      var sh = stage.clientHeight;
      var dw = base.w * scale;
      var dh = base.h * scale;
      var maxX = Math.max(0, (dw - sw) / 2);
      var maxY = Math.max(0, (dh - sh) / 2);
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    function applyTransform() {
      clampTransform();
      zoomImg.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
    }

    function close() {
      overlay.remove();
      document.body.style.overflow = '';
    }

    overlay.querySelector('.be-zoom-viewer__close').addEventListener('click', close);

    stage.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length === 2) {
          panning = false;
          startDist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          startScale = scale;
          startTx = tx;
          startTy = ty;
          e.preventDefault();
          return;
        }
        if (e.touches.length === 1) {
          lastPanX = e.touches[0].clientX;
          lastPanY = e.touches[0].clientY;
          panning = scale > 1.01;
        }
      },
      { passive: false }
    );

    stage.addEventListener(
      'touchmove',
      function (e) {
        if (e.touches.length === 2) {
          var dist = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          scale = clamp(startScale * (dist / startDist), 1, 4);
          applyTransform();
          e.preventDefault();
          return;
        }
        if (e.touches.length === 1 && panning) {
          tx += e.touches[0].clientX - lastPanX;
          ty += e.touches[0].clientY - lastPanY;
          lastPanX = e.touches[0].clientX;
          lastPanY = e.touches[0].clientY;
          applyTransform();
          e.preventDefault();
        }
      },
      { passive: false }
    );

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        panning = false;
        if (scale < 1.02) {
          scale = 1;
          tx = 0;
          ty = 0;
          applyTransform();
        }
      }
      if (e.changedTouches.length === 1 && e.touches.length === 0) {
        var now = Date.now();
        if (now - lastTap < 300) {
          if (scale > 1.2) {
            scale = 1;
            tx = 0;
            ty = 0;
          } else {
            scale = 2.2;
          }
          applyTransform();
        }
        lastTap = now;
      }
    });

    zoomImg.addEventListener('load', applyTransform);
  }

  function bindGalleryZoom() {
    if (!MOBILE.matches) return;

    document.querySelectorAll('media-gallery .product__media img').forEach(function (img) {
      if (img.dataset.beZoomBound) return;
      if (!img.closest('.product__media-item:not(.be-media-hidden)')) return;
      img.dataset.beZoomBound = '1';
      img.style.cursor = 'zoom-in';

      img.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openZoomViewer(img);
      });
    });
  }

  function init() {
    disableMagnifyOnMobile();
    bindGalleryZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', init);
  document.addEventListener('shopify:section:load', init);

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      window.setTimeout(init, 120);
    });
  }
})();
